import { defineStore } from 'pinia'

const useCentralStore = defineStore('central', {
  state: () => ({
    id: null,
    nome: null,
    descricao: null,
    url: null,
    tituloHeader: null,
    headerHtml: null,
    footerHtml: null,
    urlAlias: null,
    logoId: null,
    empresaId: null,
    empresaNome: null,

    empresaNomeFormatado: null,
    autoatendimentoNomeFormatado: null,
    requestUrl: null,
  }),

  getters: {
    isCentralDefinida: state => !!state.id,
    isRequestUrlDefinida: state => !!state.requestUrl,
  },

  actions: {
    setCentralData(data) {
      this.id = data.id
      this.nome = data.nome
      this.descricao = data.descricao
      this.url = data.url
      this.tituloHeader = data.tituloHeader
      this.headerHtml = data.headerHtml
      this.footerHtml = data.footerHtml
      this.urlAlias = data.urlAlias
      this.logoId = data.logoId
      this.empresaId = data.empresaId
      this.empresaNome = data.empresaNome
    },

    setRequestUrl(empresaNomeFormatado, autoatendimentoNomeFormatado) {
      this.empresaNomeFormatado = empresaNomeFormatado
      this.autoatendimentoNomeFormatado = autoatendimentoNomeFormatado
      this.requestUrl = `https://autoatendimento.viktech.com.br/${empresaNomeFormatado}/${autoatendimentoNomeFormatado}`
    },

    clear() {
      this.id = null
      this.nome = null
      this.descricao = null
      this.url = null
      this.tituloHeader = null
      this.headerHtml = null
      this.footerHtml = null
      this.urlAlias = null
      this.logoId = null
      this.empresaId = null
      this.empresaNome = null

      this.empresaNomeFormatado = null
      this.autoatendimentoNomeFormatado = null
      this.requestUrl = null
    },

    updateTitle() {
      const titulo = this.tituloHeader
      if (titulo) {
        document.title = titulo
      } else {
        document.title = 'VIKWAY - Central de atendimento'
      }
    },
  },

  persist: true,
})

export default useCentralStore
